export default __webpack_public_path__ + "static/media/chevron-left.4ae8e2f0.svg";